export const buildFilterObject = (filtersDef) => {
  return filtersDef.reduce((o, a) => {
            o[a.name] = a.defaultValue ? a.defaultValue : '';
            return o;
          }, {});
};



// WEBPACK FOOTER //
// ./src/main/functions/filters.js